export const cloneTracker = trackerInstance => {
  return trackerInstance.clone({
    preserveTrackerEvents: true,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library'
  });
};